<div class="catalog">
  <!-- En-tête du carousel -->
  <div class="container-catalog-label">
    <h4 class="catalog-label">
      <span class="chevron">> </span>{{ catalog.label }}
    </h4>
    <button
            mat-flat-button class="button btn-seemore" [routerLink]="['/offers/'] + catalog.searchWord">
      Voir plus
    </button>
  </div>

  <!-- Corps du carousel -->
  <div class="container-background-carousel">
    <div class="container-carousel">
      <!-- Flèche de gauche -->
      <div class="btn-carousel-chevron btn-carousel-chevron-left" (click)="prev()">&lt;</div>

      <!-- Produits -->
      <div class="carousel">
        <div #carousel class="owl-carousel owl-theme" >
          <div class="item" *ngFor="let product of catalog.products;trackBy: trackByProduct">
            <app-product-card [product]="product" [isNetPrice]="true" [activePriceListType]="'net'"></app-product-card>
          </div>
        </div>
      </div>

      <!-- Flèche de droite -->
      <div class="btn-carousel-chevron btn-carousel-chevron-right" (click)="next()">&gt;</div>
    </div>
    <!-- Ajout un fond bleu -->
    <div class="background-carousel"></div>
  </div>
</div>
